import { Col, FormLabel } from "react-bootstrap";
import HTMLEditor from "../../../components/common/HTMLEditor";
import { IFieldEditor } from "../../../../models/Interfaces";

const BodyTextEditor = (props: IFieldEditor) => {

  const onPublishedValueChange = (content: string) : void => {
    props.onValueChange(props.property.Id, content);
  };

  return (
    <>
      <FormLabel>{props.property.DisplayLabel}</FormLabel>
      <HTMLEditor preview={props.startEditing === true ? false : undefined}
        value={props.property.PublishedValue ?? props.property.DefaultValue ?? ""} 
        height={props.editorHeight}
        siteFrame={props.siteFrame}
        onChange={onPublishedValueChange} />
    </>
  );
}

export default BodyTextEditor;
